import React, { createContext, useEffect } from "react";
import useWebSocket, { ReadyState } from "react-use-websocket";
import { toast } from "sonner";

import { SOCKET_URL } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { set_global_notifications } from "../../redux/slices/globalNotificationsSlice";
import { DateTime } from "luxon";
import { getToken, success_alert } from "../../utils";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";

const GlobalSocketWrapperContext = createContext(null);

const GlobalSocketWrapper = ({ children }) => {
  const location = useLocation();
  const token = getToken()
  const intl = useIntl()
  const { unread_count, not_seen } = useSelector(state => state.global_notifications)

  const { lastMessage, lastJsonMessage, readyState, sendMessage, ...socket } =
    useWebSocket(SOCKET_URL + "notifications/" + "?token=" + token, {
      //   shouldReconnect: (closeEvent) => true,
      // reconnectAttempts: 10,
      //attemptNumber will be 0 the first time it attempts to reconnect, so this equation results in a reconnect pattern of 1 second, 2 seconds, 4 seconds, 8 seconds, and then caps at 10 seconds until the maximum number of attempts is reached
      reconnectInterval: (attemptNumber) =>
        Math.min(Math.pow(2, attemptNumber) * 1000, 10000),
    });

  const dispatch = useDispatch();
  const { sidebar_api_data } = useSelector(state => state.global_notifications)

  useEffect(() => {
    if (lastJsonMessage !== null) {
      let socket_msg = lastJsonMessage.type;
      
      console.log("lastJsonMessage", lastJsonMessage);
      // setting general notifications
      if (lastJsonMessage.type === "notify" || lastJsonMessage.type === "influencer-notify") {
      
        dispatch(
          set_global_notifications({
            not_seen: not_seen + 1,
            unread_count: unread_count + 1,
            sidebar_api_data: [
              lastJsonMessage,
              ...sidebar_api_data,
            ]
          })
        );
      }

      let message = "";
      if (lastJsonMessage.type === "notify" || lastJsonMessage.type === "influencer-notify") {
        message = intl.formatMessage({ id: "got_a_new_message", defaultMessage: "Got a new message!" })
      }

      if (message) {
        const isCampaignChat = location.pathname.match(/^\/campaign\/\d+\/chats/);
        const isNotificationsPage = location.pathname === "/notifications";

        if (!isNotificationsPage && !isCampaignChat && !location.pathname.startsWith("/chats")) {
          success_alert(message);
        }

      }
    }
  }, [lastJsonMessage]);


  return (
    <GlobalSocketWrapperContext.Provider
      value={{
        socket: "",
        sendMessage
      }}
    >
      {children}
    </GlobalSocketWrapperContext.Provider>
  );
};
export { GlobalSocketWrapperContext };
export default GlobalSocketWrapper;
